import { FormBuilder } from '@/components/formBuilder';
import { ScorecardAutoSave } from './AutoSaveScorecard';

export const CollectScoreCardForm = ({
  formRef,
  formConfig,
  handleSubmit = () => {},
  initialValues = {},
  handleAutoSave = () => {},
  status = '',
}) => {
  return (
    <FormBuilder
      formContainerProps={{ w: '100%' }}
      config={formConfig}
      onSubmit={handleSubmit}
      formRef={formRef}
      initialValues={initialValues}
      hasFormChild
      FormChild={() =>
        status !== 'submitted' ? (
          <ScorecardAutoSave onAutoSave={handleAutoSave} />
        ) : null
      }
    />
  );
};
